import SearchItem from '../SearchItem';
import { observer } from 'mobx-react';
import type { FC } from 'react';
import type { HeaderSearchSettings } from '../..';
import './index.scss';

const SearchProducts: FC<{
  products: NonNullable<HeaderSearchSettings['searchData']>['products'];
}> = ({ products }) => (
  <div className='search-products'>
    {products.length > 0 &&
      products
        .slice(0, 5)
        .map(item => (
          <SearchItem key={`search-result-${item.id}`} item={item} />
        ))}
  </div>
);

export default observer(SearchProducts);
